import { render, staticRenderFns } from "./product-sync.vue?vue&type=template&id=27b28af8&"
import script from "./product-sync.vue?vue&type=script&lang=js&"
export * from "./product-sync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports